<template>
    <input
        type="number"
        v-model="model"
        class="input"
        onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57);"
    />
</template>

<script setup lang="ts">
    const model = defineModel();
</script>

<style scoped></style>
